import { ChangeEvent } from 'react';
import { Typography } from '../../../Typography';
import { setTimeValue, toTimeValue } from '../DateInput.helpers';

export interface TimeInputProps {
  date?: Date | null;
  onChange: (date: Date) => void;
}

export const TimeInput = ({ date, onChange }: TimeInputProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const baseDate = date ?? new Date();
    const nextDate = setTimeValue(baseDate, event.target.value);
    if (nextDate) onChange(nextDate);
  };

  return (
    <label className="mt-3 flex items-center gap-2 border-0 border-t border-solid border-secondary-300 pt-3">
      <Typography className="flex-1">Time</Typography>
      <input
        type="time"
        aria-label="Time"
        className="rounded-md border border-solid border-secondary-300 bg-secondary-100 p-1 text-text-primary"
        value={toTimeValue(date)}
        onChange={handleChange}
      />
    </label>
  );
};
